// extracted by mini-css-extract-plugin
export default {"distributorTable":"DistributorsEntries_distributorTable__4+amc"};